import React, { useEffect, useState } from 'react';

import {
  dataPlanoEntrega,
  headersPlanoEntrega,
  valoresExibidosPlanoEntrega,
} from './auxiliarRegistroEntrega';
import RegistroEntregaForm from './formRegistroEntrega';
import BoxConteudo from '../../../../../../../components/BoxConteudo';
import CustomButton from '../../../../../../../components/CustomButton';
import CustomCol from '../../../../../../../components/CustomCol';
import CustomRow from '../../../../../../../components/CustomRow';
import Modal from '../../../../../../../components/Modal';
import OffCanvasFlex from '../../../../../../../components/OffCanvasFlex';
import Tabela from '../../../../../../../components/Tabela';
import theme from '../../../../../../../theme';
import {
  formataNomeMeioSiglas,
  formatarNumero,
  formatarValorFormatoDinheiro,
  formatDate,
  formatDateSimp,
} from '../../../../../../../utils/functions';

type CotacaoType = {
  id: number;
  usuarioId: number;
  entregaId: number;
  observacoes: string;
};

const RegistroEntrega: React.FC = () => {
  const [data, setData] = useState<any[]>();

  const offCanvasData =
    data?.map((item) => {
      return {
        id: item.id,
        dataRegistro:
          formatDate(item.dataRegistro) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        separadorLog: '',
        produtoDAF: item.produtoDAF.produtoFarmaceutico,
        valorUnitario: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.valorUnitario)}
          </span>
        ),
        cotacaoDolar: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.cotacaoDolar)}
          </span>
        ),
        dataCotacao: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatDateSimp(item.dataCotacao)}
          </span>
        ),
        qtdCotada: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarNumero(item.qtdCotada)}
          </span>
        ),
        valorTotal: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.valorTotal)}
          </span>
        ),

        separadorCotacao: '',
        observacoes: item.observacoes,
      };
    }) || [];

  const [showModal, setShowModal] = useState(false);
  const handleClickInserirNovo = () => {
    setShowModal(true); // 🔹 Abre o modal
  };

  const handleCloseModal = () => {
    setShowModal(false); // 🔹 Fecha o modal
  };

  return (
    <BoxConteudo boxTitulo="Registro de Entregas">
      <CustomRow>
        <CustomCol width="100%">
          <Tabela
            headers={headersPlanoEntrega}
            dataTable={dataPlanoEntrega}
            displayValues={valoresExibidosPlanoEntrega}
            dataOffCanvas={offCanvasData}
            botaoAbrirOffCanvas={false}
            showPagination={false}
            noOffCanvasTable={true}
          />
        </CustomCol>
      </CustomRow>
      <CustomCol className="d-flex justify-content-end">
        <CustomButton
          label="Novo Registro"
          bgColor={theme.colors.botaoAcao.azul}
          textColor={theme.colors.white}
          onClick={() => {
            handleClickInserirNovo();
          }}
        />
      </CustomCol>
      {/* 🔹 Modal de Novo Registro */}
      <Modal
        open={showModal}
        onHide={handleCloseModal}
        tituloModal="Novo Registro de Entrega"
        icone="inventory_2"
        // modalSize="medio"
      >
        <RegistroEntregaForm />
      </Modal>
    </BoxConteudo>
  );
};

export default RegistroEntrega;
